/**
** 组织机构： 角色管理
 */
<template>
	<div id="roleManage">
		<el-container>
				<el-header class="header">
						<div class="header-left">
								<span class="header-title">{{headerTitle}}</span>
						</div>
						<div class="header-right">
								<el-form ref="form" >
									<el-button class="button">删除</el-button>
									<el-button class="button" @click="dialogVisible = true">添加</el-button>
								</el-form>
						</div>
				</el-header>
				<el-main>
						<div class="main">
								<el-table
								ref="multipleTable"
								:data="tableData"
								tooltip-effect="dark"
								style="width: 100%"
								@selection-change="handleSelectionChange">
										<el-table-column type="selection" width="55"></el-table-column>
										<el-table-column type="index" label="序号" width="55"></el-table-column>
										<el-table-column label="登录用户名">
												<template slot-scope="scope">{{scope.row.userName}}</template>
										</el-table-column>
										<el-table-column label="密码">
												<template slot-scope="scope">{{scope.row.password}}</template>
										</el-table-column>
										<el-table-column label="角色"  show-overflow-tooltip>
												<template slot-scope="scope">{{scope.row.role}}</template>
										</el-table-column>
										<el-table-column label="操作" width="100">
												<template slot-scope="scope">
														<el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
														<span>|</span>
														<el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
												</template>
										</el-table-column>
								</el-table>
						</div>
				</el-main>
		</el-container>

		<el-dialog title="添加人员" :visible.sync="dialogVisible" class="dialog">
				<el-form ref="personForm" :model="personForm">
						<el-row>
								<el-col :span="12">
										<el-form-item label="登录用户名">
												<el-input v-model="personForm.userName" placeholder="请输入登录用户名"></el-input>
										</el-form-item>
								</el-col>
								<el-col :span="12">
										<el-form-item label="密码">
												<el-input v-model="personForm.password" placeholder="请输入密码"></el-input>
										</el-form-item>
								</el-col>
						</el-row>
						<el-row>
								<el-col :span="12">
										<el-form-item label="确认密码">
												<el-input v-model="personForm.conPassword" placeholder="请再次输入密码"></el-input>
										</el-form-item>
								</el-col>
								<el-col :span="12">
										<el-form-item label="角色">
												<el-select v-model="personForm.role" placeholder="请选择角色">
														<el-option 
																v-for="item in roleOptions"
																:key="item.value"
																:label="item.label"
																:value="item.value"></el-option>
												</el-select>
										</el-form-item>
								</el-col>
						</el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取消</el-button>
						<el-button type="primary" @click="submit()">确定</el-button>
				</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
    name:"RoleManage",
		data(){
			return {
				headerTitle:"角色设置",
				tableData:[

				],//表格内容
			}
		},
		methods:{

		}
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/backStage/children/RoleManage/RoleManage.vue